import React from "react";
import { api } from "../api";

export const POLLING_INTERVAL_MS = 5000;
export const POLLING_MAX_ATTEMPTS = 120;

const isInstallmentConfirmed = (payment, installmentId) =>
  payment?.status === "paid" &&
  payment?.installments_from_gateway?.some(
    installment =>
      installment.gateway_id === installmentId && installment.status === "paid",
  );

const fetchPayment = async paymentId => {
  try {
    const response = await api.get(`payments/${paymentId}`);
    return response.data?.payment;
  } catch {
    return null;
  }
};

/**
 * Polls the payment until the given installment is confirmed as paid.
 * Stops on unmount, on confirmation or after POLLING_MAX_ATTEMPTS requests.
 */
export const usePaymentStatusPolling = (paymentId, installmentId) => {
  const [paid, setPaid] = React.useState(false);

  React.useEffect(() => {
    if (!installmentId) {
      return;
    }

    let active = true;
    let attempts = 0;
    let timeoutId;

    const poll = async () => {
      attempts += 1;
      const payment = await fetchPayment(paymentId);

      if (!active) {
        return;
      }

      if (isInstallmentConfirmed(payment, installmentId)) {
        setPaid(true);
        return;
      }

      if (attempts < POLLING_MAX_ATTEMPTS) {
        timeoutId = setTimeout(poll, POLLING_INTERVAL_MS);
      }
    };

    timeoutId = setTimeout(poll, POLLING_INTERVAL_MS);

    return () => {
      active = false;
      clearTimeout(timeoutId);
    };
  }, [paymentId, installmentId]);

  return paid;
};
